import { useQuery } from 'react-query'
import graphQLRequest from 'CanExConfig/graphQLRequest'
import { gql } from 'graphql-request'

const FETCH_COUNTRIES = gql`
  query allCountries {
    countries {
      iso2Code
      name
    }
  }
`

const fetchCountries = () => graphQLRequest(FETCH_COUNTRIES)

export const useFetchCountries = () => {
  const {
    data: { countries: allCountries } = {},
    isLoading: isLoadingCountries,
    error: countriesError,
  } = useQuery(['allCountries'], () => fetchCountries(), {
    initialData: [],
    select: ({ countries }) => ({
      countries: countries
        ? countries.map(country => ({
            label: country.name,
            value: country.iso2Code,
          }))
        : [],
    }),
  })

  return { isLoadingCountries, countriesError, allCountries }
}
